<template>
    <div class="mian-push-wrapper">
        <div>
            <div class="title">
                {{ title }}&nbsp;&nbsp;
                <el-button type="primary" round @click="addVideoClick">{{ $t("zhiji.wiki.addVideo") }}</el-button>
                <el-button type="primary" round @click="addTipClick">{{ $t("zhiji.wiki.addTip") }}</el-button>
            </div>
            <el-table :data="tableData" border>
                <el-table-column prop="preView" :label="$t('zhiji.wiki.preView')" width="110">
                    <template slot-scope="scope">
                        <a href="javascript:;" @click="viewClick(scope.row)">{{ $t("zhiji.wiki.clickView") }}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="type" :label="$t('zhiji.wiki.type')" width="60"> </el-table-column>
                <el-table-column prop="name" :label="$t('zhiji.wiki.nameTitle')" width="120"> </el-table-column>
                <el-table-column prop="title" :label="$t('zhiji.wiki.title')" width="160"> </el-table-column>
                <el-table-column prop="baseViews" :label="$t('zhiji.wiki.baseViews')" width="120"> </el-table-column>
                <el-table-column prop="views" :label="$t('zhiji.wiki.views')"> </el-table-column>
                <el-table-column prop="baseLikeNum" :label="$t('zhiji.wiki.baseLikeNum')" width="120"> </el-table-column>
                <el-table-column prop="likeNum" :label="$t('zhiji.wiki.likeNum')"> </el-table-column>
                <el-table-column prop="videoDuration" :label="$t('zhiji.wiki.videoDuration')"> </el-table-column>
                <el-table-column prop="viewDate" :label="$t('zhiji.wiki.viewDate')" width="120"> </el-table-column>
                <el-table-column :label="$t('zhiji.common.operate')" width="320">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="editClick(scope.row)">
                            {{ $t("zhiji.wiki.edit") }}
                        </el-button>
                        <el-button v-if="scope.row.index > 0" size="mini" @click="moveUpClick(scope.row)">
                            {{ $t("zhiji.wiki.moveUp") }}
                        </el-button>
                        <el-button v-if="scope.row.index < tableData.length - 1" size="mini" @click="moveDownClick(scope.row)">
                            {{ $t("zhiji.wiki.moveDown") }}
                        </el-button>
                        <el-button size="mini" @click="deleteClick(scope.row)">
                            {{ $t("zhiji.wiki.delete") }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-control">
                <PageControl :total="count" :curPage="page" :pageLength="size" @pageChange="pageChange" />
                <div class="page-length-rank">
                    <span class="total-num">{{ $t("zhiji.materialLibrary.totalOf") + count }}</span>
                    <PageLengthSelect class="length-rank-robot" :pageRank="[10, 20, 50]" :curLength="size" @lengthChange="lengthChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import VideoModal from "./VideoModal";
import TipModal from "./TipModal";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";

export default {
    name: "MainPush",
    props: ["lang"],
    components: {
        VideoModal,
        TipModal,
        PageControl,
        PageLengthSelect
    },
    data() {
        return {
            tableData: [],
            page: 1,
            size: 10,
            count: 0,
            curLang: "",
            sectionId: ""
        };
    },
    computed: {
        title() {
            return this.$t("zhiji.wiki.mianPush");
        }
    },
    watch: {
        lang: {
            handler(val) {
                this.curLang = val;
                this.page = 1;
                this.querySectionList();
            },
            immediate: true
        },
        title() {
            this.page = 1;
            this.querySectionList();
        }
    },
    methods: {
        addVideoClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "video",
                    confirm: result => {
                        if(result.length > 0) {
                            if(!result[0].lang || (result[0].lang  !== this.curLang)) {
                                this.$confirm(this.$t("zhiji.wiki.error.reSelect"), this.$t("zhiji.wiki.error.tip"), {
                                    confirmButtonText: this.$t("zhiji.common.confirm"),
                                    cancelButtonText: this.$t("zhiji.common.cancel"),
                                    type: 'warning'
                                }).then(() => {}).catch(() => {});
                            } else {
                                this.showVideoModal({
                                    title: this.$t("zhiji.wiki.addMianVideo"),
                                    resourceId: result[0].id,
                                    lang: this.curLang,
                                    sectionId: this.sectionId,
                                    formData: {
                                        namePlatform: result[0].platformTitle || "",
                                        name: result[0].title || "",
                                        videoDuration: result[0].duration,
                                        title: result[0].videoLabel.split("||"),
                                        baseViews: result[0].playNumber || "0",
                                        baseLikeNum: result[0].likeNumber || "0",
                                        viewDate: result[0].showDate ? result[0].showDate.split(" ")[0] !== "0000-00-00" ? result[0].showDate.split(" ")[0] : "" : "",
                                        image: result[0].url
                                    }
                                });
                            }
                        }
                    }
                }
            });
        },
        showVideoModal(videoData = {}) {
            const _this = this;
            setTimeout(() => {
                this.$store.dispatch("zhiji/showModal", {
                    type: VideoModal,
                    data: {
                        ...videoData,
                        rules: {
                            name: [{ required: true, message: this.$t("zhiji.wiki.error.name") }],
                            videoDuration: [{ required: true, message: this.$t("zhiji.wiki.error.duration") }],
                            viewDate: [{ required: true, message: this.$t("zhiji.wiki.error.date") }],
                            title: [{ required: true, message: this.$t("zhiji.wiki.error.title") }],
                            image: [{ required: true, message: this.$t("zhiji.wiki.error.image") }]
                        },
                        confirm(result) {
                            if(!_this.sectionId && result && result.sectionId) {
                                _this.sectionId = result.sectionId;
                            }
                            _this.page = 1;
                            _this.queryResourceList();
                        }
                    }
                });
            }, 500);
        },
        showTipModal(tipData = {}) {
            const _this = this;
            setTimeout(() => {
                this.$store.dispatch("zhiji/showModal", {
                    type: TipModal,
                    data: {
                        ...tipData,
                        rules: {
                            name: [{ required: true, message: this.$t("zhiji.wiki.error.name") }],
                            viewDate: [{ required: true, message: this.$t("zhiji.wiki.error.date") }],
                            title: [{ required: true, message: this.$t("zhiji.wiki.error.title") }],
                            image: [{ required: true, message: this.$t("zhiji.wiki.error.tipImage") }]
                        },
                        confirm(result) {
                            if(!_this.sectionId && result && result.sectionId) {
                                _this.sectionId = result.sectionId;
                            }
                            _this.page = 1;
                            _this.queryResourceList();
                        }
                    }
                });
            }, 500);
        },
        addTipClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "ReferenceMaterialModal",
                data: {
                    type: "tip",
                    confirm: result => {
                        if(result.length > 0) {
                            if(!result[0].lang || (result[0].lang  !== this.curLang)) {
                                this.$confirm(this.$t("zhiji.wiki.error.reSelect"), this.$t("zhiji.wiki.error.tip"), {
                                    confirmButtonText: this.$t("zhiji.common.confirm"),
                                    cancelButtonText: this.$t("zhiji.common.cancel"),
                                    type: 'warning'
                                }).then(() => {}).catch(() => {});
                            } else {
                                this.showTipModal({
                                    title: this.$t("zhiji.wiki.addMianTip"),
                                    lang: this.curLang,
                                    resourceId: result[0].id,
                                    sectionId: this.sectionId,
                                    formData: {
                                        namePlatform: result[0].platformTitle || "",
                                        name: result[0].title || "",
                                        title: result[0].strategyLabel.split("||"),
                                        baseViews: result[0].playNumber || "0",
                                        baseLikeNum: result[0].likeNumber || "0",
                                        viewDate: result[0].showDate ? result[0].showDate.split(" ")[0] !== "0000-00-00" ? result[0].showDate.split(" ")[0] : "" : "",
                                        image: result[0].url
                                    }
                                });
                            }
                        }
                    }
                }
            });
        },
        editClick(data) {
            if (data.resourceType === "video") {
                this.showVideoModal({
                    title: this.$t("zhiji.wiki.editMianVideo"),
                    resourceId: data.resourceId,
                    lang: data.lang,
                    id: data.id,
                    sectionId: data.sectionId,
                    formData: {
                        ...data,
                        title: data.title.split("||")
                    }
                });
            } else if (data.resourceType === "tip") {
                this.showTipModal({
                    title: this.$t("zhiji.wiki.editMianTip"),
                    resourceId: data.resourceId,
                    lang: data.lang,
                    id: data.id,
                    sectionId: data.sectionId,
                    formData: {
                        ...data,
                        title: data.title.split("||")
                    }
                });
            }
        },
        moveUpClick(data) {
            this.zhiji
                .requestByServiceName("moveResource", {
                    id: data.id,
                    sort: data.index - 1
                })
                .then(() => {
                    this.page = 1;
                    this.queryResourceList();
                });
        },
        moveDownClick(data) {
            this.zhiji
                .requestByServiceName("moveResource", {
                    id: data.id,
                    sort: data.index + 1
                })
                .then(() => {
                    this.page = 1;
                    this.queryResourceList();
                });
        },
        deleteClick({id, type}) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: `${this.$t("zhiji.wiki.deleteTip1")}"${type}"${this.$t("zhiji.wiki.deleteTip2")}` ,
                    confirm: () => {
                        this.zhiji.requestByServiceName("deleteResource", { id }).then(() => {
                            this.page = 1;
                            this.queryResourceList();
                        });
                    }
                }
            });
        },
        viewClick(data) {
            const { resourceType, videoUrl, tipContent, tipTitle, tipUpdateTime } = data;
            if (resourceType === "video") {
                videoUrl &&
                    this.$store.dispatch("zhiji/showModal", {
                        type: "VideoViewModal",
                        data: {
                            url: videoUrl
                        }
                    });
            } else if (resourceType === "tip") {
                this.$store.dispatch("zhiji/showModal", {
                    type: "GuidesViewModal",
                    data: {
                        name: tipTitle,
                        content: tipContent,
                        updateTime: tipUpdateTime
                    }
                });
            }
        },
        pageChange(data) {
            if (this.size == data.pageLength && this.page == data.curPage) {
                return;
            }
            this.size = data.pageLength;
            this.page = data.curPage;
            this.queryResourceList();
        },
        lengthChange(data) {
            if (this.size == data) {
                return;
            }
            this.size = data;
            this.page = 1;
            this.queryResourceList();
        },
        queryResourceList() {
            this.zhiji
                .requestByServiceName("queryResourceList", {
                    lang: this.curLang,
                    page: this.page,
                    size: this.size,
                    sectionId: this.sectionId
                })
                .then(res => {
                    this.count = res.count;
                    this.tableData = res.list;
                });
        },
        querySectionList() {
            this.zhiji
                .requestByServiceName("querySectionList", {
                    lang: this.curLang,
                    page: this.page,
                    size: this.size,
                    sectionType: 'top'
                })
                .then(res => {
                    this.sectionId = res.list[0] && res.list[0].id;
                    this.queryResourceList();
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.mian-push-wrapper {
    max-width: 1390px;
    margin-top: 14px;
    background: #fff;
    padding: 16px 16px 0;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    .title{
        margin-bottom: 16px;
    }
    .page-control {
        position: relative;
        width: 100%;
        padding: 20px 0;
        text-align: center;
        background: #fff;
        .page-length-rank {
            margin-right: 20px;
            float: right;
            margin-top: 6px;
            .total-num {
                font-weight: 700;
                margin-right: 10px;
            }
            .length-rank-robot {
                top: -2px;
            }
        }
    }
    /deep/.el-table thead tr th:first-child,
    /deep/.el-table tbody tr td:first-child{padding-left:10px;}
}
</style>
